<script setup lang="ts">
const items = [
  'Akun KiriminAja sudah terverifikasi aktif.',
  'Minimal 150 pengiriman COD dan omzet ≥ Rp15.000.000 dalam 3 bulan terakhir.',
  'Persentase retur maksimal 7% per bulan.',
  'Maksimal pencairan: 50% dari nilai barang, hingga Rp50.000 per paket.',
  'Pengajuan hanya berlaku untuk pengiriman dalam 7 hari terakhir.'
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Syarat Utama Pengajuan COD Advance"
    description="COD Advance hanya tersedia untuk akun bisnis yang telah memenuhi performa dan volume pengiriman tertentu."
    hero-image="/images/cod-advance-banner-3.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <Icon
            class="text-primary flex-none"
            name="material-symbols:verified"
            :size="isMobile ? '22px' : '30px'"
          />
          <p class="text-sm lg:text-lg flex-1">
            {{ item }}
          </p>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
